import React, { createContext, useContext, useMemo } from "react";
import { useRoute } from "../../useRoute.js";
import { getAppManifestEntries } from "../../app-catalog/index.js";
import { resolveAppKeyFromRoute } from "../../app-catalog/derive/resolveRoute.js";

const PlatformContext = createContext({
  activeAppKey: null,
  activeApp: null,
  appEntries: [],
});

export function PlatformProvider({ children }) {
  const { route } = useRoute();

  const appEntries = useMemo(() => {
    const entries = getAppManifestEntries();
    return Array.isArray(entries) ? entries : [];
  }, []);

  const activeAppKey = useMemo(() => {
    const key = resolveAppKeyFromRoute(route);
    return key ? String(key) : null;
  }, [route]);

  const activeApp = useMemo(() => {
    if (!activeAppKey) return null;
    return (
      appEntries.find((entry) => String(entry?.appKey || "").trim() === activeAppKey) ||
      appEntries.find((entry) => String(entry?.id || "").trim() === activeAppKey) ||
      null
    );
  }, [activeAppKey, appEntries]);

  const value = useMemo(
    () => ({
      activeAppKey,
      activeApp,
      appEntries,
    }),
    [activeAppKey, activeApp, appEntries]
  );

  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>;
}

export function usePlatformContext() {
  return useContext(PlatformContext);
}

